import React from 'react'
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const PlacesRecreation = () => {
    const parks = [
        {
            "NAME": "Flaming Gorge National Recreation Area",
            "LAND ADMINISTRATOR": "United States Forest Service",
            "Address": "25 Utah 43, Manila, UT 84046, United States",
            "Phone No:": "435-784-3445",
            "Website": "https://www.fs.usda.gov/main/ashley/",
            "Established on": "1 October 1968"
        },
        {
            "NAME": "Glen Canyon National Recreation Area",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "Utah, United States",
            "Phone No:": "928-608-6200",
            "Website": "https://www.nps.gov/glca/index.htm",
            "Established on": "27 October 1972"
        },
        {
            "NAME": "Little Sahara National Recreation Area",
            "LAND ADMINISTRATOR": "Bureau of Land Management",
            "Address": "27020 W Sand Mountain Road, Eureka, Utah 84628",
            "Phone No:": "435-433-5960",
            "Website": "https://www.blm.gov/learn/interpretive-centers/little-sahara-recreation-area",
            "Established on": "1960"
        }
    ]
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{ imageName: "recreation1.webp", title: "National Recreation Areas" }}
            />

            {/* Main Content */}
            <div className=" mx-auto  py-12 w-full">
                {/* Intro Section */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
                        Utah's National Recreation Areas
                    </h1>
                    <p className="text-xl text-blue-700">
                        Enjoy outdoor adventures in Utah’s scenic recreation areas
                    </p>
                </div>

                {/* Parks Table */}
                <div className='flex items-center justify-center'>
                    <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
                        <div className="overflow-x-auto">
                            <table className="min-w-full ">
                                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                                    <tr>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Name
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Land Administrator
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Contact
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Website
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {parks.map((park, index) => (
                                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park.NAME}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["LAND ADMINISTRATOR"]}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["Phone No:"]}</div>
                                                <div className="text-sm text-center font-bold text-blue-900">{park.Address}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <a
                                                    href={park.Website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                                                >
                                                    Visit Website
                                                </a>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default PlacesRecreation
